import "../css/styles.css";
import "../css/oneByOne.css";
import "../css/pad.css";
import "../css/lightpad.css";
import "../css/editor.css";
import "../css/singlePage.css";
import { getMarkdownContentAndCreateMarkpage } from "./processMarkdown/getData";

getMarkdownContentAndCreateMarkpage();
